export const GA4_STANDARD_DIMENSION_SUGGESTIONS = [
  {
    parameterName: "event_name",
    displayName: "Event name",
    description: "Name of the event that was collected.",
  },
  {
    parameterName: "event_date",
    displayName: "Event date",
    description: "Date the event was logged (YYYYMMDD).",
  },
  {
    parameterName: "event_timestamp",
    displayName: "Event timestamp",
    description: "The time the event was recorded, in microseconds.",
  },
  {
    parameterName: "event_previous_timestamp",
    displayName: "Previous event timestamp",
    description: "Timestamp of the previous event for the same user.",
  },
  {
    parameterName: "event_bundle_sequence_id",
    displayName: "Bundle sequence id",
    description: "The index of the event within the bundle.",
  },
  {
    parameterName: "event_server_timestamp_offset",
    displayName: "Server timestamp offset",
    description: "Difference between collection time and upload time in milliseconds.",
  },
  {
    parameterName: "event_value_in_usd",
    displayName: "Event value (USD)",
    description: "Monetary value of the event converted to USD.",
  },
  {
    parameterName: "event_count",
    displayName: "Event count",
    description: "Number of events in the same session with this name.",
  },
  {
    parameterName: "ga_session_id",
    displayName: "GA session ID",
    description: "Identifier for the current session.",
  },
  {
    parameterName: "ga_session_number",
    displayName: "GA session number",
    description: "Session index for the user.",
  },
  {
    parameterName: "ga_session_start",
    displayName: "GA session start",
    description: "Indicates whether the event is the first in the session.",
  },
  {
    parameterName: "ga_debug_mode",
    displayName: "Debug mode",
    description: "Indicates if the event was collected while debug mode was enabled.",
  },
  {
    parameterName: "user_id",
    displayName: "User ID",
    description: "Signed-in identifier for the user associated with the event.",
  },
  {
    parameterName: "user_pseudo_id",
    displayName: "User pseudo ID",
    description: "Device scoped identifier assigned by GA4.",
  },
  {
    parameterName: "first_visit_date",
    displayName: "First visit date",
    description: "Date of the user's first visit (YYYYMMDD).",
  },
  {
    parameterName: "session_engaged",
    displayName: "Session engaged",
    description: "Indicates whether the session met the engagement criteria.",
  },
  {
    parameterName: "engagement_time_msec",
    displayName: "Engagement time (msec)",
    description: "Time that the user was actively engaged, in milliseconds.",
  },
  {
    parameterName: "session_engaged_time",
    displayName: "Session engaged time",
    description: "Total time the session was engaged, in seconds.",
  },
  {
    parameterName: "scroll",
    displayName: "Scroll percent",
    description: "Largest vertical scroll percentage for the page.",
  },
  {
    parameterName: "outbound",
    displayName: "Outbound",
    description: "Indicates whether the link click is outbound.",
  },
  {
    parameterName: "link_url",
    displayName: "Link URL",
    description: "URL that was clicked for automatically collected link events.",
  },
  {
    parameterName: "link_text",
    displayName: "Link text",
    description: "Visible text of the clicked link.",
  },
  {
    parameterName: "link_id",
    displayName: "Link ID",
    description: "HTML ID attribute for the clicked link.",
  },
  {
    parameterName: "link_classes",
    displayName: "Link classes",
    description: "CSS classes that were applied to the clicked link.",
  },
  {
    parameterName: "file_name",
    displayName: "File name",
    description: "Name of the downloaded file.",
  },
  {
    parameterName: "file_extension",
    displayName: "File extension",
    description: "Extension of the downloaded file.",
  },
  {
    parameterName: "page_location",
    displayName: "Page location",
    description: "Full URL of the page on which the event was logged.",
  },
  {
    parameterName: "page_referrer",
    displayName: "Page referrer",
    description: "URL of the referring page.",
  },
  {
    parameterName: "page_title",
    displayName: "Page title",
    description: "HTML title of the page.",
  },
  {
    parameterName: "page_path",
    displayName: "Page path",
    description: "Path portion of the page URL.",
  },
  {
    parameterName: "page_hostname",
    displayName: "Page hostname",
    description: "Hostname portion of the page URL.",
  },
  {
    parameterName: "page_referrer_class",
    displayName: "Page referrer class",
    description: "CSS class of the element that referred the page view.",
  },
  {
    parameterName: "page_referrer_title",
    displayName: "Page referrer title",
    description: "Title of the referring page.",
  },
  {
    parameterName: "language",
    displayName: "Language",
    description: "Browser language setting for the user.",
  },
  {
    parameterName: "country",
    displayName: "Country",
    description: "Country derived from the IP address.",
  },
  {
    parameterName: "region",
    displayName: "Region",
    description: "Region derived from the IP address.",
  },
  {
    parameterName: "city",
    displayName: "City",
    description: "City derived from the IP address.",
  },
  {
    parameterName: "continent",
    displayName: "Continent",
    description: "Continent derived from the IP address.",
  },
  {
    parameterName: "sub_continent",
    displayName: "Subcontinent",
    description: "Subcontinent derived from the IP address.",
  },
  {
    parameterName: "metro",
    displayName: "Metro",
    description: "Designated market area derived from the IP address.",
  },
  {
    parameterName: "device_category",
    displayName: "Device category",
    description: "Category of the device (mobile, desktop, tablet).",
  },
  {
    parameterName: "device_brand",
    displayName: "Device brand",
    description: "Brand of the device.",
  },
  {
    parameterName: "device_model",
    displayName: "Device model",
    description: "Model of the device.",
  },
  {
    parameterName: "device_language",
    displayName: "Device language",
    description: "Language configured on the device.",
  },
  {
    parameterName: "device_operating_system",
    displayName: "Device operating system",
    description: "Operating system of the device.",
  },
  {
    parameterName: "device_os_version",
    displayName: "Device OS version",
    description: "Version of the device operating system.",
  },
  {
    parameterName: "operating_system",
    displayName: "Operating system",
    description: "Operating system reported by the browser or app.",
  },
  {
    parameterName: "operating_system_version",
    displayName: "Operating system version",
    description: "Version of the operating system reported by the client.",
  },
  {
    parameterName: "platform",
    displayName: "Platform",
    description: "Platform that collected the event (web, iOS, Android).",
  },
  {
    parameterName: "app_id",
    displayName: "App ID",
    description: "App identifier reported with the event.",
  },
  {
    parameterName: "app_version",
    displayName: "App version",
    description: "Version of the app that collected the event.",
  },
  {
    parameterName: "app_install_source",
    displayName: "App install source",
    description: "Source from which the app was installed.",
  },
  {
    parameterName: "app_store",
    displayName: "App store",
    description: "Store where the app is listed.",
  },
  {
    parameterName: "browser",
    displayName: "Browser",
    description: "Browser that collected the event.",
  },
  {
    parameterName: "browser_version",
    displayName: "Browser version",
    description: "Version of the browser that collected the event.",
  },
  {
    parameterName: "screen_resolution",
    displayName: "Screen resolution",
    description: "Screen resolution of the device.",
  },
  {
    parameterName: "screen_name",
    displayName: "Screen name",
    description: "Name of the screen on which the event occurred.",
  },
  {
    parameterName: "screen_class",
    displayName: "Screen class",
    description: "Class of the screen on which the event occurred.",
  },
  {
    parameterName: "firebase_screen",
    displayName: "Firebase screen",
    description: "Firebase screen name for the event.",
  },
  {
    parameterName: "firebase_screen_class",
    displayName: "Firebase screen class",
    description: "Firebase screen class for the event.",
  },
  {
    parameterName: "firebase_screen_id",
    displayName: "Firebase screen ID",
    description: "Firebase screen identifier for the event.",
  },
  {
    parameterName: "source",
    displayName: "Source",
    description: "Source attributed to the event.",
  },
  {
    parameterName: "medium",
    displayName: "Medium",
    description: "Medium attributed to the event.",
  },
  {
    parameterName: "campaign",
    displayName: "Campaign",
    description: "Campaign attributed to the event.",
  },
  {
    parameterName: "campaign_id",
    displayName: "Campaign ID",
    description: "Identifier for the campaign attributed to the event.",
  },
  {
    parameterName: "campaign_name",
    displayName: "Campaign name",
    description: "Name of the campaign attributed to the event.",
  },
  {
    parameterName: "campaign_term",
    displayName: "Campaign term",
    description: "Term attributed to the event.",
  },
  {
    parameterName: "campaign_content",
    displayName: "Campaign content",
    description: "Content attributed to the event.",
  },
  {
    parameterName: "source_platform",
    displayName: "Source platform",
    description: "Platform of the traffic source.",
  },
  {
    parameterName: "manual_source",
    displayName: "Manual source",
    description: "Manually specified source parameter.",
  },
  {
    parameterName: "manual_medium",
    displayName: "Manual medium",
    description: "Manually specified medium parameter.",
  },
  {
    parameterName: "manual_term",
    displayName: "Manual term",
    description: "Manually specified term parameter.",
  },
  {
    parameterName: "manual_ad_content",
    displayName: "Manual ad content",
    description: "Manually specified ad content parameter.",
  },
  {
    parameterName: "session_source",
    displayName: "Session source",
    description: "Source attributed to the session.",
  },
  {
    parameterName: "session_medium",
    displayName: "Session medium",
    description: "Medium attributed to the session.",
  },
  {
    parameterName: "session_campaign",
    displayName: "Session campaign",
    description: "Campaign attributed to the session.",
  },
  {
    parameterName: "session_campaign_id",
    displayName: "Session campaign ID",
    description: "Identifier for the session level campaign.",
  },
  {
    parameterName: "session_source_platform",
    displayName: "Session source platform",
    description: "Platform of the session source.",
  },
  {
    parameterName: "session_manual_source",
    displayName: "Session manual source",
    description: "Manually set session source parameter.",
  },
  {
    parameterName: "session_manual_medium",
    displayName: "Session manual medium",
    description: "Manually set session medium parameter.",
  },
  {
    parameterName: "session_manual_term",
    displayName: "Session manual term",
    description: "Manually set session term parameter.",
  },
  {
    parameterName: "session_manual_ad_content",
    displayName: "Session manual ad content",
    description: "Manually set session ad content parameter.",
  },
  {
    parameterName: "session_default_channel_group",
    displayName: "Session default channel group",
    description: "Default channel grouping attributed to the session.",
  },
  {
    parameterName: "session_primary_channel_group",
    displayName: "Session primary channel group",
    description: "Primary channel grouping attributed to the session.",
  },
  {
    parameterName: "gclid",
    displayName: "Google click ID",
    description: "Google Ads click identifier associated with the session.",
  },
  {
    parameterName: "wbraid",
    displayName: "WBRAID",
    description: "Web conversion value identifier for some iOS campaigns.",
  },
  {
    parameterName: "gbraid",
    displayName: "GBRAID",
    description: "Google Ads identifier for app to web conversions.",
  },
  {
    parameterName: "dclid",
    displayName: "DCLID",
    description: "DoubleClick click identifier associated with the session.",
  },
  {
    parameterName: "utm_source",
    displayName: "UTM source",
    description: "UTM source parameter captured with the session.",
  },
  {
    parameterName: "utm_medium",
    displayName: "UTM medium",
    description: "UTM medium parameter captured with the session.",
  },
  {
    parameterName: "utm_campaign",
    displayName: "UTM campaign",
    description: "UTM campaign parameter captured with the session.",
  },
  {
    parameterName: "utm_term",
    displayName: "UTM term",
    description: "UTM term parameter captured with the session.",
  },
  {
    parameterName: "utm_content",
    displayName: "UTM content",
    description: "UTM content parameter captured with the session.",
  },
  {
    parameterName: "utm_id",
    displayName: "UTM ID",
    description: "UTM ID parameter captured with the session.",
  },
  {
    parameterName: "search_term",
    displayName: "Search term",
    description: "Site search term or keyword provided for the event.",
  },
  {
    parameterName: "search_category",
    displayName: "Search category",
    description: "Category associated with the search event.",
  },
  {
    parameterName: "term",
    displayName: "Keyword term",
    description: "Keyword associated with the event.",
  },
  {
    parameterName: "content_type",
    displayName: "Content type",
    description: "Type of content associated with the event.",
  },
  {
    parameterName: "content_group",
    displayName: "Content group",
    description: "Content group for the page or screen.",
  },
  {
    parameterName: "item_id",
    displayName: "Item ID",
    description: "Identifier for the item in the event items array.",
  },
  {
    parameterName: "item_name",
    displayName: "Item name",
    description: "Name for the item in the event items array.",
  },
  {
    parameterName: "item_brand",
    displayName: "Item brand",
    description: "Brand for the item in the event items array.",
  },
  {
    parameterName: "item_variant",
    displayName: "Item variant",
    description: "Variant for the item in the event items array.",
  },
  {
    parameterName: "item_category",
    displayName: "Item category",
    description: "Primary category for the item.",
  },
  {
    parameterName: "item_category2",
    displayName: "Item category 2",
    description: "Secondary category for the item.",
  },
  {
    parameterName: "item_category3",
    displayName: "Item category 3",
    description: "Tertiary category for the item.",
  },
  {
    parameterName: "item_category4",
    displayName: "Item category 4",
    description: "Fourth category for the item.",
  },
  {
    parameterName: "item_category5",
    displayName: "Item category 5",
    description: "Fifth category for the item.",
  },
  {
    parameterName: "item_list_name",
    displayName: "Item list name",
    description: "Name of the list in which the item was shown.",
  },
  {
    parameterName: "item_list_id",
    displayName: "Item list ID",
    description: "Identifier of the list in which the item was shown.",
  },
  {
    parameterName: "item_list_position",
    displayName: "Item list position",
    description: "Position of the item within the presented list.",
  },
  {
    parameterName: "item_location_id",
    displayName: "Item location ID",
    description: "Location identifier for the item.",
  },
  {
    parameterName: "item_affiliation",
    displayName: "Item affiliation",
    description: "Affiliation for the item in the event.",
  },
  {
    parameterName: "items",
    displayName: "Items array",
    description: "Serialized list of ecommerce items sent with the event.",
  },
  {
    parameterName: "quantity",
    displayName: "Quantity",
    description: "Quantity of items associated with the event.",
  },
  {
    parameterName: "price",
    displayName: "Price",
    description: "Unit price for the item in the event.",
  },
  {
    parameterName: "value",
    displayName: "Value",
    description: "Currency value associated with the event.",
  },
  {
    parameterName: "currency",
    displayName: "Currency",
    description: "Currency code associated with the event value.",
  },
  {
    parameterName: "affiliation",
    displayName: "Affiliation",
    description: "Affiliation associated with the ecommerce event.",
  },
  {
    parameterName: "coupon",
    displayName: "Coupon",
    description: "Coupon code applied during the event.",
  },
  {
    parameterName: "shipping",
    displayName: "Shipping",
    description: "Shipping cost associated with the event.",
  },
  {
    parameterName: "tax",
    displayName: "Tax",
    description: "Tax amount associated with the event.",
  },
  {
    parameterName: "discount",
    displayName: "Discount",
    description: "Discount amount associated with the event.",
  },
  {
    parameterName: "transaction_id",
    displayName: "Transaction ID",
    description: "Identifier for the purchase transaction.",
  },
  {
    parameterName: "payment_type",
    displayName: "Payment type",
    description: "Payment method associated with the purchase.",
  },
  {
    parameterName: "shipping_tier",
    displayName: "Shipping tier",
    description: "Shipping speed or tier selected for the order.",
  },
  {
    parameterName: "promotion_id",
    displayName: "Promotion ID",
    description: "Identifier for the promotion viewed or clicked.",
  },
  {
    parameterName: "promotion_name",
    displayName: "Promotion name",
    description: "Name of the promotion viewed or clicked.",
  },
  {
    parameterName: "creative_name",
    displayName: "Creative name",
    description: "Name of the creative associated with the promotion.",
  },
  {
    parameterName: "creative_slot",
    displayName: "Creative slot",
    description: "Placement of the creative associated with the promotion.",
  },
  {
    parameterName: "ad_platform",
    displayName: "Ad platform",
    description: "Advertising platform associated with the event.",
  },
  {
    parameterName: "ad_source",
    displayName: "Ad source",
    description: "Source of the advertising traffic.",
  },
  {
    parameterName: "ad_format",
    displayName: "Ad format",
    description: "Format of the ad related to the event.",
  },
  {
    parameterName: "ad_unit",
    displayName: "Ad unit",
    description: "Ad unit from which the event originated.",
  },
  {
    parameterName: "ad_campaign_id",
    displayName: "Ad campaign ID",
    description: "Advertising campaign identifier.",
  },
  {
    parameterName: "ad_group_id",
    displayName: "Ad group ID",
    description: "Advertising ad group identifier.",
  },
  {
    parameterName: "ad_group_name",
    displayName: "Ad group name",
    description: "Name of the advertising ad group.",
  },
  {
    parameterName: "ad_creative_id",
    displayName: "Ad creative ID",
    description: "Identifier for the ad creative associated with the event.",
  },
  {
    parameterName: "ad_creative_name",
    displayName: "Ad creative name",
    description: "Name of the ad creative associated with the event.",
  },
  {
    parameterName: "video_title",
    displayName: "Video title",
    description: "Title of the video that triggered the event.",
  },
  {
    parameterName: "video_url",
    displayName: "Video URL",
    description: "URL of the video that triggered the event.",
  },
  {
    parameterName: "video_duration",
    displayName: "Video duration",
    description: "Length of the video in seconds.",
  },
  {
    parameterName: "video_current_time",
    displayName: "Video current time",
    description: "Current playback position for the video in seconds.",
  },
  {
    parameterName: "video_percent",
    displayName: "Video percent",
    description: "Percentage of the video watched when the event triggered.",
  },
  {
    parameterName: "video_provider",
    displayName: "Video provider",
    description: "Platform hosting the video content.",
  },
  {
    parameterName: "video_position",
    displayName: "Video position",
    description: "Placement of the video on the page.",
  },
  {
    parameterName: "form_id",
    displayName: "Form ID",
    description: "Identifier for the form associated with the event.",
  },
  {
    parameterName: "form_name",
    displayName: "Form name",
    description: "Name of the form associated with the event.",
  },
  {
    parameterName: "form_destination",
    displayName: "Form destination",
    description: "Submission target for the tracked form.",
  },
  {
    parameterName: "prediction_id",
    displayName: "Prediction ID",
    description: "Identifier for a predictive audience or model.",
  },
  {
    parameterName: "prediction_result",
    displayName: "Prediction result",
    description: "Outcome generated by a predictive model.",
  },
]
